import { z, ZodType } from 'zod';
import { Account } from './account';
import { Permissions, permissionsSchema } from './permissions';

export type AccountEditResponse = Account & {
	permissions: Permissions;
};

export const accountEditResponseSchema: ZodType<AccountEditResponse> = z.object({
	id: z.number(),
	name: z.string(),
	note: z.string().nullable(),
	isLocked: z.boolean(),
	createdAt: z.string(),
	permissions: permissionsSchema,
});
